import { Button } from '@/components';
import { MasterTranslation } from '@/constants';
import { useGlobalState, usePreventBodyScroll } from '@/hooks';
import { ButtonSize, ButtonVariant } from '@/interfaces';
import { Dialog } from '@/modules/pmt/components/Dialog';
import type { IEmailAccount } from '@/modules/pmt/interfaces';
import { ButtonGroup } from './EmailAccountPopup.styles';

interface IEmailAccountPopupProps {
  show: boolean;
  onHide: () => void;
  email: IEmailAccount;
  handleDisconnect: () => Promise<void>;
}

export const EmailAccountPopup = ({ show, onHide, handleDisconnect }: IEmailAccountPopupProps) => {
  const { t } = useGlobalState();
  usePreventBodyScroll(show);

  return (
    <Dialog show={show} onHide={onHide}>
      <Dialog.Header />
      <Dialog.Content>
        <Dialog.MainText>{t(MasterTranslation.DisconnectEmailTitle)}</Dialog.MainText>
        <Dialog.SubText>{t(MasterTranslation.DisconnectEmailDescription)}</Dialog.SubText>
        <ButtonGroup>
          <Button truncate isPMTButton onClick={onHide} size={ButtonSize.Large} variant={ButtonVariant.Outlined}>
            {t(MasterTranslation.Cancel)?.toUpperCase()}
          </Button>
          <Button truncate isPMTButton size={ButtonSize.Large} onClick={handleDisconnect}>
            {t(MasterTranslation.Disconnect)?.toUpperCase()}
          </Button>
        </ButtonGroup>
      </Dialog.Content>
    </Dialog>
  );
};
